import React, { useState } from 'react';
import { User, CheckSquare } from 'lucide-react';

const TeamMembersCell = ({ taskMembers = [], allMembers = [], onChange, readOnly = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMember = (memberInitials) => {
    if (taskMembers.includes(memberInitials)) {
      onChange(taskMembers.filter(m => m !== memberInitials));
    } else {
      onChange([...taskMembers, memberInitials]);
    }
  };

  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <div className={`flex -space-x-2 w-full h-full justify-center items-center ${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-105 transition-transform'}`} onClick={() => { if (!readOnly) setIsOpen(!isOpen); }}>
        {taskMembers.length > 0 ? taskMembers.map((m) => {
          const memberData = allMembers.find(mem => mem.initials === m);
          const bgColor = memberData ? memberData.color : 'bg-slate-500';
          return (
            <div key={m} className={`w-6 h-6 rounded-full ${bgColor} border border-[#181b26] flex items-center justify-center text-[10px] font-bold text-white hover:z-10`}>{m}</div>
          )
        }) : (
          <div className="w-6 h-6 rounded-full bg-slate-700 border border-slate-600 border-dashed flex items-center justify-center hover:bg-slate-600">
            <User size={12} className="text-slate-400"/>
          </div>
        )}
      </div>

      {(isOpen && !readOnly) ? (
        <div className="absolute top-9 left-1/2 -translate-x-1/2 z-50 w-48 bg-slate-800 border border-slate-600 rounded shadow-xl p-2 flex flex-col gap-1">
          <div className="text-xs text-slate-400 mb-2 px-1">Atribuir a:</div>
          {allMembers.map((member) => {
            const isSelected = taskMembers.includes(member.initials);
            return (
              <div key={member.id} className="flex items-center justify-between px-2 py-1.5 cursor-pointer rounded hover:bg-slate-700" onClick={() => toggleMember(member.initials)}>
                <div className="flex items-center gap-2">
                  <div className={`w-6 h-6 rounded-full ${member.color} flex items-center justify-center text-[10px] font-bold text-white`}>{member.initials}</div>
                  <span className="text-sm text-slate-200">{member.name}</span>
                </div>
                {isSelected ? <CheckSquare size={14} className="text-blue-400" /> : null}
              </div>
            );
          })}
        </div>
      ) : null}
      {(isOpen && !readOnly) ? <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)}></div> : null}
    </div>
  );
};

export default TeamMembersCell;
